<template>
  <div class="h-100">
    <v-chart ref="chart" :options="options" :echart.sync="echart" />
  </div>
</template>

<script>
import { merge } from 'lodash';
import chartable from '@/mixins/chartable';

export default {
  mixins: [chartable],
  props: {
    settings: {
      type: Object,
      required: true,
    },
    motlet: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      options: {
        xAxis: {
          type: 'category',
          axisLabel: {
            fontWeight: 'normal',
            fontSize: 9,
            color: '#bbbbaa',
          },
        },
        yAxis: {
          nameGap: 7,
          nameTextStyle: {
            fontWeight: 'normal',
            fontSize: 11,
            color: '#bbbbaa',
          },
          minInterval: 1,
          axisLabel: {
            inside: true,
            showMinLabel: false,
            fontWeight: 'normal',
            fontSize: 9,
            color: '#bbbbaa',
          },
        },
        dataset: {
          source: [],
        },
        series: [{ type: 'bar' }],
        grid: {
          top: '5px',
          left: '18px',
          right: '11px',
          bottom: '16px',
        },
        // BEGIN::Removed.by.KWShin.2025.11.24.
        // Bar들 쓸데없이 중앙에 몰려 다닥다닥 붙어 나오는 것을 방지하기 위해 막음.
        // barCategoryGap: '70%',
        // barGap: '5%',
        // FINISH::Removed.by.KWShin.2025.11.24.
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: params => this.tooltipFormatter(params),
        },
      },
      echart: null,
    };
  },
  watch: {
    settings: {
      deep: true,
      handler() {
        this.counter = this.counter + 1;
        this.initializeChartOptions();
        this.options = merge({}, this.options, this.settings.chart);
      },
    },
  },
  computed: {
    tooltipFormatter() {
      return typeof this.settings.formatter.tooltip == 'function' ? this.settings.formatter.tooltip : function() {};
    },
  },
  methods: {
    initializeChartOptions() {
      this.options.dataset.source = [];
      this.options.series = [{ type: 'bar' }];
    },
  },
};
</script>
